import { Box, Typography } from '@mui/material'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { useMe } from '@/shared/api/auth'
import MainLogo from '@/shared/assets/img/main-logo.svg'
import { getLocalizedText } from '@/shared/utils/locale'

export const Route = createFileRoute('/_auth/')({
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation()
  const { data } = useMe()

  return (
    <Box display="flex" flexDirection="column" padding={'0 170px'} gap="32px">
      <img src={MainLogo} width={122} height={64} alt="main-logo" />
      <Box display="flex" flexDirection="column" gap="12px">
        {data && (
          <>
            <Typography fontSize={20} fontWeight={600} variant="h6">
              {t('Добро пожаловать,')}
            </Typography>
            <Typography fontSize={28} fontWeight={700} variant="body1">
              {data?.firstName} {data?.lastName}!
            </Typography>
          </>
        )}
      </Box>

      <Box
        sx={{
          backgroundColor: 'rgba(249, 249, 249, 1)',
          borderRadius: '32px',
        }}
        display="flex"
        padding={'56px'}
        flexDirection="column"
        gap="40px"
      >
        <Box>
          <Typography color="text.secondary" fontSize={16} fontWeight={600} variant="body1">
            {t('Вы вошли под ролью:')}
          </Typography>
          <Typography fontSize={24} fontWeight={400} variant="body1">
            {data?.roles.map((role) => getLocalizedText(role.nameRu, role.nameKk)).join(', ')}
          </Typography>
        </Box>

        <Box>
          <Typography color="text.secondary" fontSize={16} fontWeight={600}>
            {t('Тип компании:')}
          </Typography>
          <Typography fontSize={24} fontWeight={400}>
            {data?.company.code}
          </Typography>
        </Box>

        <Box>
          <Typography color="text.secondary" fontSize={16} fontWeight={600}>
            {t('Название компании:')}
          </Typography>
          <Typography fontSize={24} fontWeight={400}>
            {getLocalizedText(data?.company.nameRu, data?.company.nameKk)}
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}
